module.exports = __webpack_public_path__ + "static/media/13.5e46b9e5.png";